import {z} from 'zod';
import type {TranslationFunction} from 'src/types/language-support.ts';
import {getReasonSchema} from '../../utils/schema.ts';


export const getReasonFormSchema = (t: TranslationFunction) => {
  const reasonSchema = getReasonSchema(t);
  return z.object({
    reason: reasonSchema,
  });
};
